import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import JsonViewer from 'vue-json-viewer';
// 引用Echarts
import * as echarts from 'echarts'; 

import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import { ElText } from 'element-ui';
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css'
// 进度条自定义配置 [3,8](@ref)
NProgress.configure({
    easing: 'ease',       // 动画曲线
    speed: 500,           // 动画速度（ms）
    showSpinner: false,   // 隐藏加载图标
    trickleSpeed: 200,    // 自动递增间隔
    minimum: 0.3          // 初始最小百分比
  })
  
  // 路由守卫控制进度条 [2,4](@ref)
  router.beforeEach((to, from, next) => {
    NProgress.start()    // 进入路由时启动
    next()
  })
  
  router.afterEach(() => {
    NProgress.done()     // 路由加载完成后关闭
  })

  // 可选：Axios请求拦截器集成 [2,3](@ref)
  import axios from 'axios'
  axios.interceptors.request.use(config => {
    NProgress.start()
    return config
  })
  axios.interceptors.response.use(response => {
    NProgress.done()
    return response
  }, error => {
    NProgress.done()
    return Promise.reject(error)
  })
Vue.component('el-text', ElText);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.use(VueI18n); 
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;  
    var role;
    if(localStorage.getItem(window.location.hostname+'_token')!=null){
        var role = localStorage.getItem(window.location.hostname+'_token').split("@")[2];    
    }  
    if ( to.path == '/forPhone' || to.path == '/forByInfo' || to.path.indexOf('upload')>0 || to.path == '/forPass' || to.path == '/login' || to.path.indexOf('tsHandleHis')>0 ) {
        next();
    }else if (!role && to.path !== '/login') { 
        next('/login'); 
    }else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role.indexOf('nimda')>-1 ? next() : next('/403');
    } else { 
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});
// main.js 或单独文件
Vue.directive('animate-number', {
    bind(el, binding) {
        let current = 0;
        let target = parseFloat(binding.value);
        if (isNaN(target)) target = 0;

        const duration = 2000;
        const startTime = performance.now();

        // 获取保留几位小数，默认为 0
        const precision = binding.arg ? parseInt(binding.arg) : 0;

        const animate = (timestamp) => {
            const progress = Math.min((timestamp - startTime) / duration, 1);
            current = progress * target;

            // 根据精度格式化显示
            let displayValue;
            if (precision > 0) {
                displayValue = current.toFixed(precision);
            } else {
                displayValue = Math.floor(current); // 保持整数行为
            }

            el.textContent = displayValue;

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        el._animateNumber = animate;
        requestAnimationFrame(animate);
    },
    update(el, binding) {
        let target = parseFloat(binding.value);
        if (isNaN(target)) target = 0;

        // 清除旧动画
        if (el._animateNumber) {
            cancelAnimationFrame(el._rafId);
        }

        // 重新绑定动画
        Vue.directive('animate-number').bind(el, binding);
    }
});



new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
